if (!customElements.get('le-combination')) {
  customElements.define('le-combination', class extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.le-combination__toggle');
      this.panel = this.querySelector('[data-combination-panel]');
      if (!this.toggle || !this.panel || this.observer) return;
      this.onToggle = () => this.setExpanded(this.toggle.getAttribute('aria-expanded') !== 'true');
      this.toggle.addEventListener('click', this.onToggle);
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      });
      this.observer.observe(this.panel, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src', 'data-amount'] });
      this.onSelect = () => this.setExpanded(true);
      this.addEventListener('shopify:block:select', this.onSelect);
      this.refresh();
    }

    refresh() {
      const title = this.panel.querySelector('.ppcse-title-c');
      const images = [...this.panel.querySelectorAll('.ppcse-img-lt-img, .ppcse-m-img-lt-img')];
      const items = [...this.panel.querySelectorAll('input[type="checkbox"]')];
      const total = this.panel.querySelector('.ppcse-tot-container-tot .lb-upsell-money, .ppcse-m-tot-lt-tot .lb-upsell-money');
      if (!title || !items.length || !total) {
        this.panel.hidden = false;
        this.toggle.hidden = true;
        this.classList.remove('is-enhanced');
        this.signature = null;
        return;
      }
      const selected = items.filter(item => item.checked).length;
      const signature = JSON.stringify([title.textContent, total.textContent, selected, images.map(image => image.src)]);
      if (signature !== this.signature) {
        this.querySelector('[data-combination-title]').textContent = title.textContent.trim();
        this.querySelector('[data-combination-total]').textContent = `${selected > 1 ? `${selected} ${this.dataset.productsLabel} · ` : ''}${total.textContent.trim()}`;
        this.querySelector('.le-combination__images').replaceChildren(...images.slice(0, 3).map(source => {
          const image = document.createElement('img');
          image.src = source.src;
          image.alt = '';
          image.width = 40;
          image.height = 40;
          image.loading = 'lazy';
          return image;
        }));
        this.signature = signature;
      }
      this.toggle.hidden = false;
      if (!this.classList.contains('is-enhanced')) {
        this.classList.add('is-enhanced');
        this.setExpanded(this.expanded ?? Boolean(window.Shopify?.designMode));
      }
    }

    setExpanded(expanded) {
      this.expanded = expanded;
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.panel.hidden = !expanded;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      cancelAnimationFrame(this.frame);
      this.toggle?.removeEventListener('click', this.onToggle);
      this.removeEventListener('shopify:block:select', this.onSelect);
    }
  });
}
